import React from "react";
import { Link } from "react-router-dom";
import { Megaphone, Search } from "lucide-react";
import { announcements } from "../data/mock";

const AnnouncementBar = ({ onSearchOpen }) => {
  const items = [...announcements, ...announcements];
  return (
    <div className="bg-brand-dark text-surface overflow-hidden">
      <div className="flex items-center max-w-[1900px] mx-auto">
        <Link
          to="/announcements"
          className="flex items-center gap-2 px-4 py-3 bg-brand text-surface flex-shrink-0 font-sans-ui text-sm uppercase tracking-widest hover:bg-brand-darker transition-colors"
        >
          <Megaphone size={16} />
          <span className="hidden sm:inline">Announcements</span>
        </Link>
        <div className="relative flex-1 overflow-hidden">
          <div
            className="flex gap-12 marquee-track py-3 whitespace-nowrap"
            style={{ animationDuration: "75s" }}
          >
            {items.map((m, i) => {
              const isExternal = m.link && m.link.startsWith("http");
              const MarqueeComponent = isExternal ? "a" : Link;
              const marqueeProps = isExternal
                ? { href: m.link, target: "_blank", rel: "noopener noreferrer" }
                : { to: m.link || `/announcement/${m.id}` };

              return (
                <MarqueeComponent
                  {...marqueeProps}
                  key={`${m.id}-${i}`}
                  className="text-[15px] font-sans-ui flex items-center gap-3 hover:text-white hover:underline cursor-pointer"
                >
                  <span className="w-1.5 h-1.5 rounded-full bg-surface/70" />
                  {m.highlight && (
                    <span className="px-1.5 py-0.5 text-[9px] bg-amber-500 text-brand-dark font-extrabold rounded animate-pulse inline-flex items-center justify-center tracking-wider mr-1">
                      NEW
                    </span>
                  )}
                  {m.text}
                </MarqueeComponent>
              );
            })}
          </div>
        </div>
        <button
          type="button"
          onClick={onSearchOpen}
          className="flex h-11 items-center justify-center gap-2 px-4 bg-brand text-surface hover:bg-brand-darker transition-colors flex-shrink-0 font-sans-ui text-sm uppercase tracking-widest"
          aria-label="Open search"
          title="Search"
        >
          <Search size={18} />
          <span className="hidden sm:inline">Search</span>
        </button>
      </div>
    </div>
  );
};

export default AnnouncementBar;
